import axios from 'axios'
import axiosCancel from 'axios-cancel'
import store from './store'
import router from './router'
import {Raven} from 'vue-raven'
import {AUTH_AUTO_REQUEST, AUTH_LOGOUT, AUTH_REQUEST, AUTH_SET_STAFF_ACCESS_TOKEN} from './store/mutations'
import {Env} from '../env'

axiosCancel(axios, {
    debug: false
})

axios.defaults.baseURL = `${Env.apiUrl}/api`
axios.defaults.headers.common['x-platform'] = Env.xPlatform
axios.defaults.headers.common['x-origin'] = Env.xOrigin

const token = store.getters.getToken
if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

let isTokenRefreshing = false
let subscribers = []

function onAccessTokenFetched(access_token) {
    subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
    subscribers.push(callback)
}

axios.interceptors.request.use(
    config => {
        if (config.url.includes(Env.workflowUrl)) { // TODO: CORS error with x-origin param?
            delete config.headers.common['x-origin']
        }
        return config
    },
    error => Promise.reject(error)
)

axios.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        if (error && error.response) {
            const {config, response: {status}} = error
            const originalRequest = config

            if (config && status === 401) { // Unauthorized
                if ([AUTH_REQUEST, AUTH_AUTO_REQUEST].includes(config.requestId) ||
                    (config.url && config.url.startsWith(Env.workflowUrl))) {
                    throw error
                }

                // Setting staff access token may also fail with the same 401 code
                if (config.requestId === AUTH_SET_STAFF_ACCESS_TOKEN) {
                    store.commit(AUTH_LOGOUT)
                    return router.push({name: 'login'}).catch(() => {
                    })
                }

                // Impersonate staff user (if auto-login fails)
                if (store.getters.isStaff) {
                    if (!isTokenRefreshing) {
                        isTokenRefreshing = true
                        const newToken = await store.dispatch(AUTH_SET_STAFF_ACCESS_TOKEN)
                        if (newToken) {
                            onAccessTokenFetched(newToken)
                        }
                        isTokenRefreshing = false
                    }

                    // retry original request
                    return new Promise((resolve) => {
                        addSubscriber(access_token => {
                            originalRequest.headers['Authorization'] = 'Bearer ' + access_token
                            resolve(axios(originalRequest))
                        })
                    })
                } else {
                    store.commit(AUTH_LOGOUT)
                    return router.push({name: 'login'}).catch(() => {
                    })
                }
            } else {
                if (!axios.isCancel(error)) {
                    Raven.captureException(error)
                }
            }
        }
        return Promise.reject(error)
    })
